import React, { useEffect, useState, Fragment } from "react";
import {
    AppBar as KAppBar,
    AppBarSection,
    AppBarSpacer,
    Menu,
    MenuItem,
} from "@progress/kendo-react-layout";
import "./AppBar.css";
import Search from "./Search/Search";
import { ReactComponent as GearIcon } from "../icons/gear.svg";
import jwt_decode from "jwt-decode";
import { useSelector, useDispatch } from "react-redux";
import { setDisclaimerOpen, setAboutWinOpen } from "../redux/toolSelectSlice";
import TokenRefresh from "../auth/TokenRefresh";
import { authServer, getCookie } from "../api/axios";
import { deducePermissions } from "../redux/permissionSlice";
import { makeArray } from "../permissionUtils";

const UserSettingsIcon = () => {
    return <GearIcon />;
};

const mobile = window.innerWidth < 601 ? true : false;

const AppBar = () => {
    const dispatch = useDispatch();
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const layers = useSelector((state) => state.configData.layers);
    const permissions = useSelector((state) => state.configData.permissions);

    const [siteName, setSiteName] = useState("");
    const token = getCookie("ast");
    let userGivenName = "Guest";
    let tokenRoles = ["GUEST"];
    if (token) {
        userGivenName = jwt_decode(token).name;
        tokenRoles = jwt_decode(token).realm_access.roles;
    }
    useEffect(() => {
        if (!mapConfig) {
            setSiteName("");
        } else {
            setSiteName(`${mapConfig.DisplayName}`);
            const authedRoles = makeArray(mapConfig.Permissions).filter((i) =>
                tokenRoles.includes(i.Value)
            );
            if (
                authedRoles.length === 0 &&
                tokenRoles.filter((i) => i.includes("GUEST")).length === 1
            ) {
                //Not Auth Go To Login and Site is Secure
                window.location.href = window.location.origin + "/login";
            } else if (authedRoles.length === 0) {
                //User Not Authorized or has become unauthorized since login
                window.location.href = window.location.origin + "/sessionexpired";
                console.error("User was LOGGED OUT while active");
            } else {
                dispatch(deducePermissions([authedRoles, layers, permissions]));
            }
        }
    }, [mapConfig]);
    const handleMenuItemClick = (e) => {
        // This function will be called when the MenuItem is clicked
        switch (e.item.text) {
            case "Disclaimer":
                dispatch(setDisclaimerOpen(true));
                break;
            case "About":
                dispatch(setAboutWinOpen(true));
                break;
            case "Help":
                break;
            case "Logout":
                break;
            default:
        }
    };

    return (
        <KAppBar>
            <div className="appbar-items-left">
                <AppBarSection className="logo">
                    <img src={process.env.REACT_APP_SAM_LOGO_URL} alt="SAM Logo" />
                </AppBarSection>
                <span className="vertical-bar" />
                <AppBarSection>
                    <h1 className="title">{siteName}</h1>
                </AppBarSection>
            </div>
            <Search />
            <AppBarSection>
                <Fragment>
                    <Menu
                        hoverCloseDelay={500}
                        onSelect={handleMenuItemClick}
                        className="user-menu-button">
                        <MenuItem key="user-menu" render={UserSettingsIcon}>
                            {!token && (
                                <MenuItem
                                    key="user-login"
                                    icon="login"
                                    text="Login"
                                    url="/login"
                                />
                            )}
                            {token.length > 0 && (
                                <MenuItem
                                    key="user-logout"
                                    icon="logout"
                                    text="Logout"
                                    url="/logout"
                                />
                            )}
                            {token.length > 0 && (
                                <MenuItem key="user-admin" icon="user" text="Account" />
                            )}
                            <MenuItem key="client-info" icon="info-circle" text="About" />
                            <MenuItem
                                key="site-disclaimer"
                                icon="exclamation-circle"
                                text="Disclaimer"
                            />
                            <MenuItem
                                key="site-help"
                                icon="question-circle"
                                text="Help"
                            />
                        </MenuItem>
                    </Menu>
                    <div className="user">
                        <h3>{userGivenName}</h3>
                    </div>
                </Fragment>
            </AppBarSection>
            <TokenRefresh></TokenRefresh>
        </KAppBar>
    );
};

export default AppBar;
